import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import Notifications from 'vue-notification'
Vue.use(Notifications)

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

import Datepicker from 'vue2-datepicker';
Vue.component('datepicker', Datepicker)
//==============vue-editor=======================
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/js/plugins/colors.min.js'
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
//===============vue-chat-scroll=================
import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)
//================feather icons==================
import VueFeather from 'vue-feather';
Vue.use(VueFeather);
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
//================moment=========================
Vue.use(require('vue-moment'))
//================paginate=======================
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)
//==============vee-validate=====================
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
//=========phone number with country code========
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);






//========local components import globally=======
import header from '@/components/fxView/shared/header'
Vue.component('app-header', header)
import top_header_title from '@/components/fxView/shared/top_header_title'
Vue.component('app-top-header-title', top_header_title)
import pagination from '@/components/fxView/shared/pagination'
Vue.component('app-pagination', pagination)
import loaderComponent from '@/components/fxView/shared/loader_component'
Vue.component('app-loader-component', loaderComponent)
import confirmation from '@/components/fxView/shared/confirmation'
Vue.component('app-confirm', confirmation)

import html2canvas from 'html2canvas'
window.html2canvas = html2canvas

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js